import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { type App } from "vue";
import { Consoler } from "@/utils/Consoler";
import { Config } from "@/utils/Config";
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";

export function useAppInsights(app: App): void {
  const instrumentationkey = Config.AppInsightsInstrumentationKey;
  const applicationId = Config.AppInsightsApplicationId;

  if (!instrumentationkey || !applicationId) {
    Consoler.warn("AppInsights not configured. Skipping initialization.");
    return;
  }
  const clickPluginInstance = new ClickAnalyticsPlugin();
  // Click Analytics configuration
  const clickPluginConfig = {
    autoCapture: true,
    dataTags: {
      useDefaultContentNameOrId: true,
    },
  };
  const connectionsString = `InstrumentationKey=${instrumentationkey};IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=${applicationId}`;
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionsString,
      extensions: [clickPluginInstance],
      extensionConfig: {
        [clickPluginInstance.identifier]: clickPluginConfig,
      },
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

  app.provide("appInsights", appInsights);
}
